import { useCategoryStore } from "@/stores/category";
import CategoriesServices from "@/services/Category";
import Api from "@/services/Api";
import { buildLabelRuleFields } from "@/constants/labelRules";
// import helpers from "@/helpers.js";

export default async function editAccessoryCategory(parent_category) {
	let categories = useCategoryStore()
	var related_entity = 'accessories'

	// Get users list for product_manager field
	var managers_list = [];
	await Api(true)
		.get("/user/get/users")
		.then((res) => {
			managers_list = res.data.map((a) => {
				a.label = a.name;
				return a;
			});
		});

	let attr_list = await CategoriesServices.getAttributesList(
		-1,
		'products'
	);
	categories.attributes = attr_list.map((d) => {
		d.id = d.guid;
		d.label = d.name;
		return d;
	});
	var parent_attr_list = await CategoriesServices.getParentAttributeList(
		parent_category,
		related_entity,
		0
	);
	categories.inherited_attributes = parent_attr_list.map((d) => {
		d.id = d.guid;
		d.label = d.name;
		return d;
	});
	categories.categories_attributes = await CategoriesServices.getParentAttributeList(
		parent_category,
		related_entity,
		1
	);
	var selected_options = {}
	var categories_attributes_config = [];
	if (categories.categories_attributes) {
		var currentCategoryAttrs = categories.categories_attributes
			.filter((ca) => ca.category_id === categories.current.guid)
			.map((ca) => ({
				attribute_id: ca.attribute_id,
				name: ca.attribute_name || ca.name,
				is_required: !!ca.is_required,
				is_label: !!ca.is_label,
				for_label_title: !!ca.for_label_title,
				sort_nr: ca.sort_nr != null ? ca.sort_nr : 999,
				sort_nr_label: ca.sort_nr_label != null ? ca.sort_nr_label : ca.sort_nr ?? 0,
				web_sort_nr: ca.web_sort_nr != null ? ca.web_sort_nr : ca.sort_nr ?? 0,
				show_in_web: !!ca.show_in_web,
				show_in_web_as_filter: !!ca.show_in_web_as_filter,
				measuring_unit: ca.measuring_unit ?? null,
				default_measuring_unit: ca.default_measuring_unit ?? null,
				measuring_unit_name: ca.measuring_unit_name ?? null,
				input_type_override: ca.input_type_override ?? null,
				default_input_type: ca.type_id ?? null,
			}))
			.sort((a, b) => (a.web_sort_nr ?? a.sort_nr ?? 999) - (b.web_sort_nr ?? b.sort_nr ?? 999));
		categories_attributes_config = currentCategoryAttrs.map((a, i) => ({
			...a,
			sort_nr: a.sort_nr ?? i,
			sort_nr_label: a.sort_nr_label ?? a.sort_nr ?? i,
			web_sort_nr: a.web_sort_nr ?? i,
		}));
		categories.categories_attributes.map(ca => {
			var found = false
			categories.inherited_attributes.map(ia => {
				if(ia.attribute_id == ca.attribute_id || ia.guid == ca.attribute_id) found = true
			})
			if(!found) selected_options[ca.attribute_id] = ca.attribute_name || ca.name
		})
	}

	// Accessories categories
	// let accessories_list = await CategoriesServices.getCategories("accessories")
	// // Assign the accessories to categories
	// categories.accessories = helpers.toTree(accessories_list, "id")

	// var parent_acc_list = await CategoriesServices.getParentAccessoryList(
	// 	parent_category,
	// 	related_entity,
	// 	0
	// );

	
	// Get services categories
	let service_types = await CategoriesServices.getServicesCategories()
	categories.services = service_types.map((d) => {
		d.id = d.guid;
		d.label = d.name;
		return d;
	});

	var selected_options_service_type = {}
	if(categories.categories_service_types)
		categories.categories_service_types.map(ca => { 
			if(ca.category_id == categories.current.guid)
				selected_options_service_type[ca.service_type_id] = ca.name 
		})

	var parent_service_type_list = await CategoriesServices.getParentServiceTypeList(
		parent_category,
		0
	);
	categories.inherited_service_types = parent_service_type_list.map((d) => {
		d.id = d.guid;
		d.label = d.name;
		return d;
	});

	// create sort list 
	var sort_options = []
	// var index = 0 
	categories.flat_list.map(f => {
		if(f.parent_id == categories.current.parent_id){
			sort_options.push({
				id: f.sort_nr,
				label: f.sort_nr
			})
			// index += 1
		}
	})

	// form: (a, related_entity) => {
	return {
		name: "<span class='mr-1'>Modifiko</span> <b>" + categories.current.name + "</b>",
		submit: {
			label: 'Modifiko', 
			action: 'submitAccessory'
		},
		delete: {
			guid: categories.current.guid,
			model: 'Category',
			api: 'category/delete/' + related_entity,
			permission: 'product.can_delete_product_accessory',
		},
		fields: [
			[
				{ 
					value: categories.current.code, 
					name: 'code', 
					label: 'Kodi', 
					type: 'text-field', 
					unique: {
						model: 'accessory', 
						field: 'code',
						where: [
							{
								column: 'related_entity',
								condition: '=',
								value: related_entity 
							},
							{
								column: 'guid',
								condition: '!=',
								value: categories.current.guid 
							}
						]
					},  
					left_icon: 'fa-solid fa-hashtag', 
					style: "min-width: 45%",
					required: true,
				},
				{
					value: categories.current.name, 
					name: 'name', 
					label: 'Emri', 
					type: 'text-field', 
					style: "min-width: 45%",
					required: true,
					required_text: 'Kjo fushe eshte e detyrueshme'
				},
				{
					value: categories.current.active, 
					name: 'active', 
					label: 'Aktiv', 
					type: 'checkbox-field', 
					style: "min-width: 2%",
					unique: true, 
				},
			{
				value: categories.current.sort_nr, 
				name: 'sort_nr', 
				label: 'Renditja', 
				type: 'select-field', 
				options: sort_options,
				style: "",
			},
		],
		[
			{
				value: categories.current.product_manager,
				name: 'product_manager',
				label: 'Menaxheri i produktit',
				type: 'select-field',
				style: 'flex: 1',
				options: managers_list,
				options_group: 'type_id',
				options_group_label: 'type_name',
				required_text: 'Autofillon menaxherin e produktit kur krijohet produkt aksesor ne kete kategori',
			},
		],
		...buildLabelRuleFields(categories.current),
		{ 
			value: categories.current.description, 
			name: 'description',
				label: 'Pershkrim', 
				type: 'textarea-field',
			},
			{
				name: 'categories_attributes',
				label: 'Atributet',
				type: 'category-attributes-config',
				style: 'width: 100%',
				options: categories.attributes.filter(a => {
					var found = false
					categories.inherited_attributes.map(aa => {
						if(aa.attribute_id == a.id) found = true
					})
					return !found
				}),
				value: categories_attributes_config,
				required: false
			},
			{
				name: 'categories_services', 
				label: 'Tipet e sherbimeve', 
				type: 'tree-select', 
				style: 'width: 100%',
				// options: categories.services, 
				options: categories.services.filter(a => {
					var found = false
					categories.inherited_service_types.map(aa => {
						if(aa.service_type_id == a.id) found = true
					})
					return !found
				}), 
				selected_options: selected_options_service_type,
				inherited_selected_options: categories.inherited_service_types,
				mode: 'multiple',
				required: false
			},


			// {
			// 	name: "categories_accessories",
			// 	label: "Aksesoret",
			// 	type: "tree-select",
			// 	style: "min-width: 30%",
			// 	// options: accessories,
			// 	// selected_options: [],

			// 	options: categories.accessories.filter(a => {
			// 		var found = false
			// 		categories.inherited_accessories.map(aa => {
			// 			if(aa.accessory_id == a.id) found = true
			// 		})
			// 		return !found
			// 	}), 
			// 	selected_options: selected_options_accessories,
			// 	inherited_selected_options: categories.inherited_accessories,

			// 	mode: 'multiple',
				
			// },
		]
	};
}
